<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02"><em>Preface</em></a></p>
<p class="toc"><a href="#/c01">I</a></p>
<p class="toc"><span href="#/c02" title="Link target outside of Sample">II</span></p>
<p class="toc"><span href="#/c03" title="Link target outside of Sample">III</span></p>
<p class="toc"><span href="#/c04" title="Link target outside of Sample">IV</span></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">V</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">VI</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">VII</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">VIII</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">IX</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">X</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">XI</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">XII</span></p>
<p class="toc"><span href="#/c13" title="Link target outside of Sample">XIII</span></p>
<p class="toc"><span href="#/c14" title="Link target outside of Sample">XIV</span></p>
<p class="toc"><span href="#/c15" title="Link target outside of Sample">XV</span></p>
<p class="toc"><span href="#/c16" title="Link target outside of Sample">XVI</span></p>
<p class="toc"><span href="#/c17" title="Link target outside of Sample">XVII</span></p>
<p class="toc"><span href="#/c18" title="Link target outside of Sample">XVIII</span></p>
<p class="toc"><span href="#/c19" title="Link target outside of Sample">XIX</span></p>
<p class="toc"><span href="#/c20" title="Link target outside of Sample">XX</span></p>
<p class="toc"><span href="#/c21" title="Link target outside of Sample">XXI</span></p>
<p class="toc"><span href="#/c22" title="Link target outside of Sample">XXII</span></p>
<p class="toc"><span href="#/c23" title="Link target outside of Sample">XXIII</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">About the Author</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">Connect with HMH</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0490b4cf